/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdColorPickerProps } from './type';

export const colorPickerDefaultProps: TdColorPickerProps = {
  borderless: false,
  closeBtn: true,
  colorModes: ['monochrome', 'linear-gradient'],
  enableAlpha: false,
  format: 'RGB',
  multiple: false,
  defaultRecentColors: [],
  showPrimaryColorPreview: true,
};
